import Plus from "./SVG/plus.svg?react";

const PlusIcon = () => {
  return <Plus />;
};

export default PlusIcon;
